import Vue from 'vue'

// 注意 有些组件使用异步加载会有影响
Vue.component('d2-table', () => import('./d2-table/index.vue'))
Vue.component('basic-dialog', () => import('./basic-dialog/index.vue'))
Vue.component('rule-form', () => import('./rule-form/index.vue'))
Vue.component('glsx-dialog', () => import('./glsx-dialog/index.vue'))
Vue.component('glsx-combi-form', () => import('./glsx-combi-form/index.vue'))
